export type TriggerIdType = number

export interface AutomationRuleTriggerInterface {
  id?: TriggerIdType
  buttonId?: string
  checkBoxId?: string
  formId?: string
  type: AutomationRuleTriggersEnum
  preventSaving?: boolean
}

export interface AutomationRuleTriggerApiInterface
  extends Omit<AutomationRuleTriggerInterface, 'id' | 'preventSaving'> {
  id: TriggerIdType
}

export type TriggerKeyType = keyof Pick<
  AutomationRuleTriggerInterface,
  'buttonId' | 'checkBoxId' | 'formId'
>

export enum AutomationRuleTriggersEnum {
  form_subscribed = 'form_subscribed',
  blog_page_form_subscribed = 'blog_page_form_subscribed',
  website_form_subscribed = 'website_form_subscribed',
}
